import { allProblems, allSessions, ProblemRecord } from './db';

export interface ChapterScore {
  chapter: string;
  score: number;
  count: number;
}

function confidenceScore(p: ProblemRecord): number {
  if (p.confidence === 'got_it') return 100;
  if (p.confidence === 'sorta') return 60;
  if (p.confidence === 'lost') return 25;
  return 50;
}

export async function chapterScores(): Promise<Record<string, number>> {
  const problems = await allProblems();
  const buckets = new Map<string, number[]>();
  for (const p of problems) {
    const key = p.chapter ?? 'misc';
    const arr = buckets.get(key) ?? [];
    arr.push(confidenceScore(p));
    buckets.set(key, arr);
  }
  const out: Record<string, number> = {};
  buckets.forEach((scores, key) => {
    const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
    out[key] = Math.round(avg);
  });
  return out;
}

export async function totalMinutes(): Promise<number> {
  const sessions = await allSessions();
  return Math.round(sessions.reduce((acc, s) => acc + s.minutes, 0));
}

export async function lastActive(): Promise<number> {
  const problems = await allProblems();
  return problems[0]?.timestamp ?? 0;
}

export async function recentProblems(limit = 10) {
  const problems = await allProblems();
  return problems.slice(0, limit).map((p) => ({
    chapter: p.chapter,
    topic: p.topic,
    input_type: p.input_type,
    hints_used: p.hints_used,
    confidence: p.confidence,
    timestamp: p.timestamp,
  }));
}

export async function problemsSolved(): Promise<number> {
  const problems = await allProblems();
  return problems.length;
}
